import Vue from "vue";
import router from "../router/index";
import axios from "axios";
import ajax from "./ajax.js";
import LocalStorage from "./localStorage.js";

const fileUrl = process.env.FILE_SERVICE;

const apiHost = process.env.VAT_SERVICE;

Vue.filter("wq_capitalize", (value, f) => {
  if (!f) f = "yyyy-MM-dd";
  if (!value) return "";
  if (!f) f = "yyyy-MM-dd hh:mm";
  var elem = new Date(value);
  var o = {
    "M+": elem.getMonth() + 1, //月
    "d+": elem.getDate(), //d日
    "h+": elem.getHours(), //时
    "m+": elem.getMinutes(), //分
    "s+": elem.getSeconds(), //秒
    "q+": Math.floor((elem.getMonth() + 3) / 3),
    S: elem.getMilliseconds()
  };
  if (/(y+)/.test(f))
    f = f.replace(
      RegExp.$1,
      (elem.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(f))
      f = f.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return f;
});
Vue.filter("docStatus", (value, f) => {
  if (!value) return "";
  if (value == "PUBLISHED") {
    return "已发布";
  } else if (value == "DRAFT") {
    return "草稿";
  } else if (value == "OFFLINE") {
    return "已下架";
  }
});
// 产品套餐状态
Vue.filter("productStatusStr", value => {
  if (!value) return "";
  if (value == "Draft") {
    return "待销售(草稿)";
  } else if (value == "OnSelling") {
    return "销售中";
  } else if (value == "Disabled") {
    return "停售";
  }
});
Vue.filter("package", value => {
  if (value == "normal") {
    return "产品服务";
  } else if (value == "combo") {
    return "产品套餐服务";
  }
});
Vue.filter("status", val => {
  if (val === "draft") {
    return "草稿";
  } else if (val === "unaudit") {
    return "待审核";
  } else if (val === "audited") {
    return "审核通过";
  } else if (val === "deleted") {
    return "已删除";
  } else if (val === "rejected") {
    return "驳回";
  } else if (val === "invalid") {
    return "已过期";
  }
});
Vue.filter("timeFilter", value => {
  if (value === "year") {
    return "年";
  } else if (value === "month") {
    return "月";
  } else if (value === "day") {
    return "日";
  } else {
    return "无";
  }
});

var proTime = null; //loading开始倒计时
var proTime1 = null; //loading结束倒计时
function progressTimer(progressXQ) {
  if (progressXQ.value != 60) {
    progressXQ.value++;
    // progressXQ.value = val;
  } else {
    clearTimeout(proTime);
    proTime = null;
  }
  proTime = setTimeout(() => {
    progressTimer(progressXQ);
  }, 100);
}

function progressTimer1(progressXQ) {
  if (progressXQ.value != 100) {
    progressXQ.value++;
    // progressXQ.value = val;
  } else {
    progressXQ.style.display = "none";
    clearTimeout(proTime);
    clearTimeout(proTime1);
    proTime = null;
    proTime1 = null;
  }
  proTime1 = setTimeout(() => {
    progressTimer1(progressXQ);
  }, 10);
}
let util = {
  timeFormat: (value, f) => {
    if (!f) f = "yyyy-MM-dd";
    if (!value) return "";
    var elem = new Date(value);
    var o = {
      "M+": elem.getMonth() + 1, // 月
      "d+": elem.getDate(), // d日
      "h+": elem.getHours(), // 时
      "m+": elem.getMinutes(), // 分
      "s+": elem.getSeconds(), // 秒
      "q+": Math.floor((elem.getMonth() + 3) / 3),
      S: elem.getMilliseconds()
    };
    if (/(y+)/.test(f))
      f = f.replace(
        RegExp.$1,
        (elem.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(f))
        f = f.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    }
    return f;
  },
  Export(data, fileName) {
    // 文件流下载
    const blob = new Blob([data]);
    if ("download" in document.createElement("a")) {
      // 非IE下载
      const elink = document.createElement("a");
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName);
    }
  },

  formDownload(action, params) {
    // params 数组，多个订单号

    var dlform = document.createElement("form");
    dlform.style = "display:none;";
    dlform.method = "post";
    dlform.action = `${apiHost}${action}`;
    dlform.target = "_blank";
    dlform.name = "dssdszx";
    dlform.enctype = "multipart/form-data";
    var hdnFilePath = document.createElement("input");
    let token = localStorage["accessToken"];
    hdnFilePath.type = "hidden";
    hdnFilePath.name = "access_token";
    hdnFilePath.value = token;
    dlform.appendChild(hdnFilePath);
    var oids = document.createElement("input");
    oids.type = "hidden";
    oids.name = "oids";
    oids.value = params.join(",");
    console.log("oids", params.join());
    dlform.appendChild(oids);
    document.body.appendChild(dlform);
    dlform.submit();
    document.body.removeChild(dlform);
  },

  DownLoadImg(url) {
    return axios
      .get(fileUrl + url, {
        responseType: "blob",
        headers: { Authorization: "Bearer " + localStorage["accessToken"] }
      })
      .then(response => {
        return Promise.resolve(response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getImgBlob(url, fn) {
    if (!url || url == "string") return;
    if (
      url.indexOf(".pdf") !== -1 ||
      url.indexOf(".png") !== -1 ||
      url.indexOf(".jpg") !== -1 ||
      url.indexOf(".jpeg") !== -1 ||
      url.indexOf(".PNG") !== -1 ||
      url.indexOf(".JPG") !== -1 ||
      url.indexOf(".JPEG") !== -1
    ) {
      let api = "";
      if (url.indexOf("modelfiles") !== -1) {
        // 模板文件地址 处理
        let fileTypeAry = url.split("/");
        api = `/Admin/ModelFile/${fileTypeAry[fileTypeAry.length - 1]}`;
      } else {
        api = "/Admin/" + url;
      }
      this.DownLoadImg(api).then(res => {
        let b = window.URL.createObjectURL(res);
        if (fn) {
          fn(b);
        }
      });
    } else {
      //非图片
      let b = "../static/img/file.png";
      if (url.indexOf(".zip") !== -1 || url.indexOf(".rar") !== -1) {
        b = "../static/img/zip.png";
      } else if (url.indexOf(".txt") !== -1) {
        b = "../static/img/txt.png";
      } else if (url.indexOf(".doc") !== -1 || url.indexOf(".docx") !== -1) {
        b = "../static/img/word.png";
      } else if (url.indexOf(".pdf") !== -1) {
        b = "../static/img/pdf.png";
      }
      if (fn) {
        fn(b);
      }
    }
  },

  // 获取地址栏参数（iframe里的）
  getUrlParams() {
    let str = location.href;
    let num = str.indexOf("?");
    const param = {};
    str = str.substr(num + 1);
    const arr = str.split("&");
    for (let i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("=");
      if (num > 0) {
        const name = arr[i].substring(0, num);
        const value = arr[i].substr(num + 1);
        param[name] = decodeURI(value);
      }
    }
    return param;
  },
  gotoEmail: function(mail) {
    var mailUrl = mail.split("@")[1];
    mailUrl = mailUrl.toLowerCase();
    if (mailUrl == "163.com") {
      return "http://mail.163.com";
    } else if (mailUrl == "vip.163.com") {
      return "http://vip.163.com";
    } else if (mailUrl == "126.com") {
      return "http://mail.126.com";
    } else if (
      mailUrl == "qq.com" ||
      mailUrl == "vip.qq.com" ||
      mailUrl == "foxmail.com"
    ) {
      return "http://mail.qq.com";
    } else if (mailUrl == "gmail.com") {
      return "http://mail.google.com";
    } else if (mailUrl == "sohu.com") {
      return "http://mail.sohu.com";
    } else if (mailUrl == "tom.com") {
      return "http://mail.tom.com";
    } else if (mailUrl == "vip.sina.com") {
      return "http://vip.sina.com";
    } else if (mailUrl == "sina.com.cn" || mailUrl == "sina.com") {
      return "http://mail.sina.com.cn";
    } else if (mailUrl == "tom.com") {
      return "http://mail.tom.com";
    } else if (mailUrl == "yahoo.com.cn" || mailUrl == "yahoo.cn") {
      return "http://mail.cn.yahoo.com";
    } else if (mailUrl == "tom.com") {
      return "http://mail.tom.com";
    } else if (mailUrl == "yeah.net") {
      return "http://www.yeah.net";
    } else if (mailUrl == "21cn.com") {
      return "http://mail.21cn.com";
    } else if (mailUrl == "hotmail.com") {
      return "http://www.hotmail.com";
    } else if (mailUrl == "sogou.com") {
      return "http://mail.sogou.com";
    } else if (mailUrl == "188.com") {
      return "http://www.188.com";
    } else if (mailUrl == "139.com") {
      return "http://mail.10086.cn";
    } else if (mailUrl == "189.cn") {
      return "http://webmail15.189.cn/webmail";
    } else if (mailUrl == "wo.com.cn") {
      return "http://mail.wo.com.cn/smsmail";
    } else if (mailUrl == "139.com") {
      return "http://mail.10086.cn";
    } else {
      return "";
    }
  },
  clickTitle(title = "") {
    if (title != "") document.title = title;
  },
  //点击顶部导航
  clickTitNav(key, staus, id) {
    if (staus) {
      localStorage["vatStaus"] = staus;
    } else {
      localStorage.removeItem("vatStaus");
    }

    let time = new Date().getTime();

    if (key == "ProductAndServceMenuItem") {
      //产品与服务
      router.push({ path: `/home` });
    } else if (key == "ExpenseCenterMenuItem") {
      //费用中心
      router.push({ path: `/vsCost/${key}` });
    } else if (key == "UserCenterMenuItem") {
      //用户中心
      router.push({ path: `/usUserInfo`, query: { id: staus } });
    } else if (key == "PlatformStoreManagementMenuItem") {
      //绑定店铺
      router.push({ path: `/vsBind/${key}` });
    } else if (key == "TenantManagementMenuItem") {
      // 客户管理
      router.push({ path: `/userManager` });
    } else if (key == "ImportedTenantListMenuItem") {
      // VAT客户
      router.push({ path: `/vatManager` });
    } else if (key == "VatHomeAdminMenuItem") {
      //VAT首页
      router.push({ path: `/vatHome`, query: { time } });
    } else if (key == "VatUserListAdminMenuItem") {
      //VAT首页
      router.push({ path: `/vatUserList`, query: { time } });
    } else if (key == "VatCrmUserListAdminMenuItem") {
      //crm客户
      router.push({ path: `/vatCrmUserList`, query: { time } });
    } else if (key == "VatCrmChannelListAdminMenuItem") {
      //crm渠道
      router.push({ path: `/vatCrmChannelList`, query: { time } });
    } else if (key == "VatCrmServiceListAdminMenuItem") {
      //crm服务
      router.push({ path: `/vatCrmServiceList`, query: { time } });
    } else if (key == "VatCrmProjectListAdminMenuItem") {
      //crm项目
      router.push({ path: `/vatCrmProjectList`, query: { time } });
    } else if (key == "VatCrmAgentListAdminMenuItem") {
      //crm项目
      router.push({ path: `/vatCrmAgentList`, query: { time } });
    } else if (key == "VatCrmProductOrderListAdminMenuItem") {
      //crm订单列表
      router.push({ path: `/vatCrmProductOrderList`, query: { time } });
    } else if (key == "VatCrmNewUserListAdminMenuItem") {
      //crm新客户
      router.push({ path: `/vatCrmNewUserList`, query: { time } });
    } else if (key == "VatCrmNewServiceListAdminMenuItem") {
      //crm协议
      router.push({ path: `/vatCrmNewServiceList`, query: { time } });
    } else if (key == "VatOrderMenuItem") {
      if (staus) {
        window.localStorage.setItem("vatOtherGo", staus);
      }
      router.push({
        path: `/vatRegisterOrder`,
        query: { time, id, otype: "edit" }
      }); //VAT注册
    } else if (key == "VatIOSSOrderMenuItem") {
      router.push({
        path: `/vatIOSSOrder`,
        query: { time, id, otype: "edit" }
      }); //IOSS管理
    } else if (key == "VatIOSSDeclaredOrderMenuItem") {
      router.push({
        path: `/vatIOSSDeclaredOrder`,
        query: { time, id, otype: "edit" }
      }); //IOSS申报
    } else if (key == "VatIOSSOfflineMenuItem") {
      router.push({ path: `/vatIOSSOffline`, query: { time } }); //IOSS线下操作
    } else if (key == "VatNoMenuItem") {
      router.push({ path: `/VatNo`, query: { time } }); //VAT税号管理
    } else if (key == "VatCountryMenuItem") {
      router.push({ path: `/VatCountry`, query: { time } }); //VAT 国家业务管理
    } else if (key == "VatTaxMenuItem") {
      router.push({ path: `/VatTax`, query: { time } }); //VAT国 税代管理
    } else if (key == "VatDeclarationMenuItem") {
      //VAT申请
      router.push({ path: `/vatApply`, query: { time, id, otype: "edit" } });
    } else if (key == "VatLetterMenuItem") {
      //VAT 信件管理
      router.push({ path: `/vatLetter`, query: { time } });
    } else if (key == "MyVatOtherFunctionsAdminMenuItem") {
      //VAT 其他业务
      router.push({
        path: `/vatOtherBusiness`,
        query: { time, id, otype: "edit" }
      });
    } else if (key == "VatOfflineDataMenuItem") {
      //VAT线下资料
      router.push({ path: `/vatOfflineData`, query: { time } });
    } else if (key == "VatHistoryMenuItem") {
      //VAT操作记录
      router.push({ path: `/vatHistory`, query: { time } });
    } else if (key == "ComplianceAdminMenuItem") {
      //合规服务 欧代/英代
      router.push({ path: `/eneurList` });
    } else if (key == "EPRAdminMenuItem") {
      router.push({ path: `/eprList` });
    } else if (key == "InsuranceUnUserListAdminMenuItem") {
      //保险服务 潜在客户
      router.push({ path: `/insuranceUnUserList` });
    } else if (key == "TradeMarkRegisterAdminMenuItem") {
      //商标注册
      router.push({ path: `/regTrademark` });
    } else if (key == "TradeMarkRetrievalAdminMenuItem") {
      //商标检索
      router.push({ path: `/trademarkRetrieval` });
    } else if (key == "SoftwareCopyrightAdminMenuItem") {
      //计算机软件著作登记
      router.push({ path: `/tradPcSoftware` });
    } else if (key == "ArtWorksCopyrightAdminMenuItem") {
      //美术作品版权
      router.push({ path: `/tradArt` });
    } else if (key == "NewsManagementMenuItem") {
      //新闻列表
      router.push({ path: `/newsList` });
    } else if (key == "UpsertNewsOperator") {
      //添加新闻
      router.push({ path: `/addNews` });
    } else if (key == "NewsCategoryMenuItem") {
      //新闻分类
      router.push({ path: `/categories` });
    } else if (key == "BannerMenuItem") {
      //banner
      router.push({ path: `/banner` });
    }
    // else if(key == "4"){                 //搜索标签管理
    //   router.push({path:`/tagsManager`})
    // }
    else if (key == "ManualManagementMenuItem") {
      //文档列表
      router.push({ path: `/docList` });
    } else if (key == "UpsertManualOperator") {
      //添加文档
      router.push({ path: `/addDoc` });
    } else if (key == "ManualCategoryMenuItem") {
      //文档分类
      router.push({ path: `/docCategories` });
    } else if (key == "NotiManagementMenuItem") {
      //人工通知
      router.push({ path: `/manualNotification` });
    } else if (key == "BannerMenuItem") {
      //广告banner
      router.push({ path: `/banner` });
    } else if (key == "SystemMessageMenuItem") {
      //系统通知
      router.push({ path: `/systemMessage` });
    }
    // else if(key == "44"){                 //文档搜索标签管理
    //   router.push({path:`/docTagsManager`})
    // }
    else if (key == "businessMenuItem") {
      //开发者中心-企业信息
      router.push({ path: `/businessInfo` });
    } else if (key == "appListMenuItem") {
      //开发者中心-应用列表
      router.push({ path: `/appList` });
    } else if (key == "developerListMenuItem") {
      //开发者中心-开发者列表
      router.push({ path: `/developerList` });
    } else if (key == "editDeveloperDocMenuItem") {
      //开发者中心-发布文档
      router.push({ path: `/editDeveloperDoc` });
    } else if (key == "developerDocTypeMenuItem") {
      //开发者中心-文档分类
      router.push({ path: `/developerDocType` });
    } else if (key == "storeCenterAuthorization") {
      //数据统计-店铺中心授权
      router.push({ path: `/storeCenterAuthorization` });
    } else if (key == "userStatistics") {
      //数据统计-用户统计
      router.push({ path: `/userStatistics` });
    } else if (key == "userVATBusinessStatistics") {
      //数据统计-用户VAT业务统计
      router.push({ path: `/userVATBusinessStatistics` });
    } else if (key == "userTrademarkBusinessStatistics") {
      //数据统计-用户商标业务统计
      router.push({ path: `/userTrademarkBusinessStatistics` });
    } else if (key == "userTrackingServiceStatistics") {
      //数据统计-用户轨迹服务统计
      router.push({ path: `/userTrackingServiceStatistics` });
    } else if (key == "userERPServiceStatistics") {
      //数据统计-用户ERP服务统计
      router.push({ path: `/userERPServiceStatistics` });
    } else if (key == "customerSpendingBehavior") {
      //数据统计-客户消费行为
      router.push({ path: `/customerSpendingBehavior` });
    } else if (key == "trajectoryService") {
      //数据统计-轨迹服务
      router.push({ path: `/trajectoryService` });
    } else if (key == "trajectoryDataAnalysis") {
      //数据统计-轨迹服务
      router.push({ path: `/trajectoryDataAnalysis` });
    } else if (key == "purchaselist") {
      //财务管理-收款
      router.push({ path: `/purchaselist` });
    } else if (key == "appRover") {
      router.push({ path: `/appRover` });
    } else if (key == "refundlist") {
      //财务管理-支出
      router.push({ path: `/refundlist` });
    } else if (key == "packageManagement") {
      //产品服务-套餐管理
      router.push({ path: `/packageManagement` });
    } else if (key == "productManagement") {
      //产品服务-产品管理
      router.push({ path: `/productManagement` });
    } else if (key == "vatProductManagement") {
      //税号产品管理服务
      router.push({ path: `/vatProductManagement` });
    } else if (key == "productBack") {
      //税号产品管理服务-退款管理
      router.push({ path: `/productBack` });
    } else if (key == "sysRevise") {
      //系统订单管理-修订管理
      router.push({ path: `/sysRevise` });
    } else if (key == "vatProductBuy") {
      //税号产品管理服务-购买管理
      if (id) {
        router.push({
          path: "/vatProductBuy/detail",
          query: { id }
        });
      } else {
        router.push({ path: `/vatProductBuy` });
      }
    } else if (key == "invoiceManage") {
      //税号产品管理服务-发票管理
      router.push({ path: `/invoiceManage` });
    } else if (key == "renewTip") {
      router.push({ path: `/renewTip` });
    } else if (key == "trackingAnalysis") {
      //轨迹追踪-物流轨迹分析配置
      router.push({ path: `/trackingAnalysis` });
    } else if (key == "trackingChase") {
      //轨迹追踪-物流轨迹分析配置
      router.push({ path: `/trackingChase` });
    } else if (key == "trackingYeeQueryWaybill") {
      //轨迹追踪-运单查询管理
      router.push({ path: `/trackingYeeWaybillQueryList` });
    } else if (key == "distributionSystem") {
      //分销系统
      router.push({ path: `/channelManagement` });
    } else if (key == "channelManagement") {
      //渠道管理
      router.push({ path: `/channelManagement` });
    } else if (key == "userManagement") {
      //用户管理
      router.push({ path: `/userManagement` });
    } else if (key == "fundDetails") {
      //资金明细
      router.push({ path: `/fundDetails` });
    } else if (key == "orderDetails") {
      //订单明细
      router.push({ path: `/orderDetails` });
    }
  },

  // loading开始
  proTimer(progressXQ) {
    if (progressXQ.value != 60) {
      progressXQ.value++;
      // progressXQ.value = val;
    } else {
      clearTimeout(proTime);
      proTime = null;
    }
    proTime = setTimeout(() => {
      this.proTimer(progressXQ);
    }, 100);
  },
  // loading开始
  beginLoading() {
    var progressXQ = document.getElementById("progressXQ");
    document.getElementById("loadingXQ").style.display = "block";
    progressXQ.style.display = "block";
    progressXQ.value = 0;
    progressTimer(progressXQ);
  },
  // loading结束
  finishLoading() {
    document.querySelector("#loadingXQ").style.display = "none";
    var progressXQ = document.getElementById("progressXQ");
    progressTimer1(progressXQ);
  },
  /*
      * todo 输入框change事件 ，；,;分割字段
      * */
  wq_inputChange(a, b, _this, ref) {
    let str = this.wq_replaceSymbol(_this[a], "fh");
    if (!Array.isArray(str)) {
      if (_this[b].indexOf(str) == -1 && str) {
        _this[b].push(str);
        _this.$refs[ref].clear();
        _this[a] = "";
      } else if (_this[b].indexOf(str) != -1 && str) {
        _this.$message({
          message: `您已经添加过 “${str}” ！`,
          type: "warning"
        });
        _this[a] = str;
      }
    } else {
      for (let item of str) {
        if (_this[b].indexOf(item) == -1) _this[b].push(item);
      }
      _this.$refs[ref].clear();
      _this[a] = "";
    }
  },
  /*
* todo 取出符号 ;；,，
* */
  wq_replaceSymbol(str, status) {
    while (str.indexOf("，") != -1) {
      ///  循环替换中文逗号
      str = str.replace("，", ",");
    }
    while (str.indexOf("；") != -1) {
      ///  循环替换中文分号
      str = str.replace("；", ",");
    }
    while (str.indexOf(";") != -1) {
      ///  循环替换英文分号
      str = str.replace(";", ",");
    }
    if (str.indexOf(",") != -1) {
      ///  包含符号
      // if (status == 'fh' ) {               ///  change事件  符号分割
      let arr = str.split(",").filter(item => item);
      // for (let i in str.split(",")) {   ///  逗号分隔之后遍历 当取出项分割后取出项不为第一项，且前一项不为空 则传出前一项
      //   if (i != 0 && str.split(",")[i - 1]) return str.split(",")[i - 1]
      // }
      let brr = [];
      arr.forEach(t => {
        brr.push(t.trim());
      });
      return brr;
      // } else {
      //   for (let item of str.split(",")) { ///  enter 事件则传出去不为空的项
      //     if (item) return item;
      //   }
      // }
    } else {
      if (status == "enter" && str) {
        let arr = str.split(",").filter(item => item);
        let brr = [];
        arr.forEach(t => {
          brr.push(t.trim());
        });
        return brr;
      }
    }
  },
  /*
   * todo 输入框enter事件 enter分割字段
   * */
  wq_enterChange(a, b, _this, ref) {
    let str = this.wq_replaceSymbol(_this[a], "enter");
    if (!Array.isArray(str)) {
      if (_this[b].indexOf(str) == -1 && str) {
        _this[b].push(str);
        _this.$refs[ref].clear();
        _this[a] = "";
      } else if (_this[b].indexOf(str) != -1 && str) {
        _this.$message({
          message: `您已经添加过 “${str}” ！`,
          type: "warning"
        });
        _this[a] = str;
      }
    } else {
      for (let item of str) {
        if (_this[b].indexOf(item) == -1) _this[b].push(item);
      }
      _this.$refs[ref].clear();
      _this[a] = "";
    }
  },
  //百分比数据处理
  percentFormat(num) {
    if (num === null) return "-";
    if (num === 0) {
      return "0%";
    } else {
      // 为了处理 js中乘法计算出现多位小数
      let n = num.toString();
      let m = 0;
      try {
        m += n.split(".")[1].length;
      } catch (e) {}
      return (Number(n.replace(".", "")) * 100) / Math.pow(10, m) + "%";
    }
  },
  percentClass(num) {
    if (num === null) return "";
    let n = Number(num);
    if (n < 0) {
      return "colorF2";
    } else {
      return "color39";
    }
  },
  OrderStatusFormat(key) {
    // 运单状态
    let statusJson = {
      Pending: "等待查询",
      NotFound: "查询不到",
      InfoReceived: "预报发货",
      InTransit: "运输途中",
      ArrivedDelivery: "到达待取",
      Delivering: "派送途中",
      Delivered: "成功派送",
      DeliveryFailure: "投递失败",
      Return: "包裹退回",
      Exception: "包裹异常",
      Delete: "不在查询"
    };
    if (statusJson.hasOwnProperty(key)) {
      return statusJson[key];
    } else {
      return "";
    }
  },
  filterCarriers(code) {
    let text = "";
    LocalStorage.get("carriers").map(function(item) {
      if (code === item.code) {
        text = item.zhName;
      }
    });
    return text;
  },
  filterCountryCarriers(code) {
    let text = code;
    LocalStorage.get("carriers").map(function(item) {
      if (code === item.country.alpha2Code) {
        text = item.country.cnName;
      }
    });
    return text;
  }
};

window.clickTitNav = util.clickTitNav;
window.clickTitle = util.clickTitle;
window.beginLoading = util.beginLoading;
window.finishLoading = util.finishLoading;
export default util;



// WEBPACK FOOTER //
// ./src/public/common.js